import {Text, TextProps} from '@chakra-ui/react';

export const AnswerHeading = (props: TextProps) => (
  <Text as="h3" display={{base: 'none', lg: 'block'}} fontSize="lg" fontWeight="700" align="center" {...props} />
);
